// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"loader_loaderOverlay__kEIB1","loader":"loader_loader__1AOoV","spin":"loader_spin__jlXXz"};